<template>
    <v-card tile>
        <v-tabs
        v-model="tab"
        background-color="primary"
        dark
        >
            <v-tab>Personal Information</v-tab>
            <v-tab>Quote</v-tab>
        </v-tabs>

        <v-tabs-items v-model="tab">
            <v-tab-item>
                <v-card flat>
                    <v-card-text>
                        <ValidationObserver ref="observer1">
                            <v-form ref="personalform">
                                <v-list flat>
                                    <v-list-item>
                                        <v-list-item-content>
                                            <ValidationProvider v-slot="{ errors }" name="First Name" rules="required">
                                                <v-text-field
                                                v-model="form.first_name"
                                                :error-messages="errors"
                                                label="First Name"
                                                required
                                                ></v-text-field>
                                            </ValidationProvider>
                                            <ValidationProvider v-slot="{ errors }" name="Last Name" rules="required">
                                                <v-text-field
                                                v-model="form.last_name"
                                                :error-messages="errors"
                                                label="Last Name"
                                                required
                                                ></v-text-field>
                                            </ValidationProvider>
                                            <ValidationProvider v-slot="{ errors }" name="Email" rules="required|email">
                                                <v-text-field
                                                v-model="form.email"
                                                :error-messages="errors"
                                                label="E-mail"
                                                required
                                                ></v-text-field>
                                            </ValidationProvider>
                                            <ValidationProvider v-slot="{ errors }" name="Phone" rules="required">
                                                <v-text-field
                                                v-model="form.phone"
                                                :error-messages="errors"
                                                label="Phone"
                                                required
                                                ></v-text-field>
                                            </ValidationProvider>
                                            <ValidationProvider v-slot="{ errors }" name="Street Address" rules="required">
                                                <v-text-field
                                                v-model="form.street_address"
                                                :error-messages="errors"
                                                label="Street Address"
                                                required
                                                ></v-text-field>
                                            </ValidationProvider>
                                            <ValidationProvider v-slot="{ errors }" name="City" rules="required">
                                                <v-text-field
                                                v-model="form.city"
                                                :error-messages="errors"
                                                label="City"
                                                required
                                                ></v-text-field>
                                            </ValidationProvider>
                                            <ValidationProvider v-slot="{ errors }" name="State" rules="required">
                                                <v-select
                                                    v-model="form.state"
                                                    :items="states"
                                                    item-text="label"
                                                    item-value="value"
                                                    :error-messages="errors"
                                                    label="Select a State"
                                                    data-vv-name="state"
                                                    required
                                                ></v-select>
                                            </ValidationProvider>
                                            <ValidationProvider v-slot="{ errors }" name="Zip Code" rules="required">
                                                <v-text-field
                                                v-model="form.zip"
                                                :error-messages="errors"
                                                label="Zip Code"
                                                required
                                                ></v-text-field>
                                            </ValidationProvider>
                                            <ValidationProvider v-slot="{ errors }" name="Preffered Contact Method" rules="required">
                                                <v-select
                                                    v-model="form.preffered_contact"
                                                    :items="preffered_contact"
                                                    item-text="label"
                                                    item-value="value"
                                                    :error-messages="errors"
                                                    label="Preffered Contact Method"
                                                    data-vv-name="preffered_contact"
                                                    required
                                                ></v-select>
                                            </ValidationProvider>
                                            <ValidationProvider v-slot="{ errors }" name="Best Time to Contact" rules="required">
                                                <v-select
                                                    v-model="form.preffered_time"
                                                    :items="preffered_time"
                                                    item-text="label"
                                                    item-value="value"
                                                    :error-messages="errors"
                                                    label="Best Time to Contact"
                                                    data-vv-name="preffered_time"
                                                    required
                                                ></v-select>
                                            </ValidationProvider>
                                            <ValidationProvider v-slot="{ errors }" name="How did they hear about Mr. Pool" rules="required">
                                                <v-select
                                                    v-model="form.how_did_hear"
                                                    :items="how_did_hear"
                                                    item-text="label"
                                                    item-value="value"
                                                    :error-messages="errors"
                                                    label="How did they hear about Mr. Pool?"
                                                    data-vv-name="how_did_hear"
                                                    required
                                                ></v-select>
                                            </ValidationProvider>
                                        </v-list-item-content>
                                    </v-list-item>
                                </v-list>
                            </v-form>
                        </ValidationObserver>
                    </v-card-text>
                    <v-divider></v-divider>
                    <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn color="blue darken-1" text to="/dashboard">Cancel</v-btn>
                        <v-btn color="primary darken-1" text @click="goToQuote">Go to Quote</v-btn>
                    </v-card-actions>  
                </v-card>
            </v-tab-item>
            <v-tab-item>
                <v-card flat tile>
                    <v-toolbar flat dark color="#003e72" class="quote-bar" tile>
                        <v-spacer></v-spacer>
                        <v-toolbar-items>
                            <v-btn dark text class="title font-weight-bold">Estimation: {{ subTotal | currency }}</v-btn>
                        </v-toolbar-items>
                        <v-spacer></v-spacer>
                    </v-toolbar>
                    <v-card-text>
                        <ValidationObserver ref="observer2">
                            <v-form ref="calform">
                                <v-list two-line subheader flat>
                                    <v-list-item>
                                        <v-list-item-content>
                                            <ValidationProvider v-slot="{ errors }" name="Size" rules="required">
                                                <v-select
                                                    v-model="form.size"
                                                    :items="sizes"
                                                    item-text="title"
                                                    item-value="id"
                                                    :error-messages="errors"
                                                    label="Select a Size"
                                                    data-vv-name="size"
                                                    required
                                                ></v-select>
                                            </ValidationProvider>
                                            <ValidationProvider v-slot="{ errors }" name="County" rules="required">
                                                <v-select
                                                    v-model="form.county"
                                                    :items="counties"
                                                    item-text="title"
                                                    item-value="id"
                                                    :error-messages="errors"
                                                    label="Select a County"
                                                    data-vv-name="county"
                                                    required
                                                ></v-select>
                                            </ValidationProvider>
                                        </v-list-item-content>
                                    </v-list-item>
                                </v-list>
                                <v-divider></v-divider>
                                <v-list two-line subheader flat>
                                    <v-subheader class="pt-5">Options</v-subheader>
                                    <v-list-item v-for="(option, index) in filteredOptions" :key="index">
                                        <v-list-item-action>
                                            <v-checkbox v-model="form.pooloptions" :value="option.id"></v-checkbox>
                                        </v-list-item-action>
                                        <v-list-item-content>
                                            <v-list-item-title>{{ option.title }}</v-list-item-title>
                                            <v-list-item-subtitle>{{ option.price | currency }}</v-list-item-subtitle>
                                        </v-list-item-content>
                                    </v-list-item>
                                </v-list>
                            </v-form>
                        </ValidationObserver>
                    </v-card-text>
                    <v-divider></v-divider>
                    <v-card-actions>
                        <v-spacer></v-spacer>
                         <v-btn color="blue darken-1" text to="/dashboard">Cancel</v-btn>
                        <v-btn color="primary darken-1" text @click="submit">Create Lead</v-btn>
                    </v-card-actions>  
                </v-card>
            </v-tab-item>
        </v-tabs-items>
    </v-card>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import { required } from 'vee-validate/dist/rules'
import { extend, ValidationObserver, ValidationProvider, setInteractionMode } from 'vee-validate'

setInteractionMode('eager')

extend('required', {
    ...required,
    message: '{_field_} can not be empty',
})

export default {
    data () {
        return {
            tab: null,
            form: {
                first_name: '',
                last_name: '',
                email: '',
                phone: '',
                street_address: '',
                city: '',
                state: 'AL',
                zip: '',
                preffered_contact: '',
                preffered_time: '',
                how_did_hear: '',
                service: 'New Pool Construction',
                size: null,
                county: null,
                pooloptions: [],
            },
        }
    },

    computed: {
        ...mapGetters({
            counties: 'data/counties',
            sizes: 'data/sizes',
            options: 'data/options',
            states: 'data/states',
            preffered_time: 'data/preffered_time',
            preffered_contact: 'data/preffered_contact',
            how_did_hear: 'data/how_did_hear',
            filteredOptions: 'data/filteredOptions',
            requiredTotal: 'data/requiredTotal'
        }),
        sizePrice() {
            let sizePrice = 0

            if(this.form.size !== null) {
                let sizeArr = this.sizes.filter(size => {
                    return size.id == this.form.size
                })

                sizePrice += parseFloat(sizeArr[0].price) + this.requiredTotal
            }

            return sizePrice 
        },
        countyPrice() {
            let countyPrice = 0

            if(this.form.county !== null) {
                let countyArr = this.counties.filter(county => {
                    return county.id == this.form.county
                })

                countyPrice += parseFloat(countyArr[0].price)
            }

            return countyPrice
        },
        optionsTotal() {
            let optionsTotal = 0
            this.form.pooloptions.forEach(option => {
                let optionArr = this.filteredOptions.filter(fo => {
                    return fo.id == option
                })
                
                optionsTotal += parseFloat(optionArr[0].price)
                
            })
            return optionsTotal
        },
        subTotal() {
            return this.sizePrice + this.countyPrice + this.optionsTotal
        }
    },
    components: {
        ValidationProvider,
        ValidationObserver,
    },
    methods: {
        ...mapActions({
            addLead: 'data/addLead'
        }),
        async submit() {
            let valid1 = await this.$refs.observer1.validate()
            let valid2 = await this.$refs.observer2.validate()

            if(valid1 && valid2) {
                this.loading = true
                this.addLead(this.form).then(response => {
                    this.$store.commit('SET_SNACKTYPE', 'green')
                    this.$store.commit('SET_SNACK', 'Successfully saved!')
                    this.$router.push({ path: `/lead/${response.id}` })
                }).catch(() => {
                    this.loading = false
                    this.$store.commit('SET_SNACKTYPE', 'red')
                    this.$store.commit('SET_SNACK', 'Failed to save! Please try again.')
                })
            } else {
                this.$store.commit('SET_SNACKTYPE', 'red')
                this.$store.commit('SET_SNACK', 'Please check your form for the errors.')

                if(!valid1) {
                    this.tab = 0
                }
            }
        },
        async goToQuote () {
            let valid = await this.$refs.observer1.validate()

            if(valid) {
                this.tab = 1
                this.$vuetify.goTo(0)
            }
        }
    }
}
</script>
<style lang="sass" scoped>
.estimation
    background: #003e72
    color: #fff
    text-align: center
    justify-content: center
    font-size: 20px
    margin: -16px -16px 20px
header
    &.quote-bar
        position: sticky
        top: 0
        z-index: 999
</style>